import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import moment from 'moment';
import * as React from 'react';
import { toast } from 'sonner';
import { getDisplayName } from '../../../models/NameUtils';
import { copyToClipboard } from '../../../models/UiUtils';
import { AdminPermission } from '../../../viewmodels/AdminViewModels';
import { IImportJob } from '../../../viewmodels/AppViewModels';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { ClipboardIcon } from '../../../web/components/svgs/icons/ClipboardIcon';
import { brandPrimary, brandPrimaryHover } from '../../../web/styles/colors';
import { baseStyleSheet } from '../../../web/styles/styles';
import { ConditionalAccess } from '../ConditionalAccess';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	onForceRevertImport?(e: React.MouseEvent<HTMLElement>): void;
	isReverting?: boolean;
	importJob: IImportJob;
	revertImport?(e: React.MouseEvent<HTMLElement>): void;
	styles?: StyleDeclarationValue[];
	showButton?: boolean;
	downloadFile?(e: React.MouseEvent<HTMLElement>): void;
}

class _ImportJobAccount extends React.PureComponent<IProps> {
	public render() {
		const { className, styles, importJob, revertImport, downloadFile, onForceRevertImport, isReverting, showButton } =
			this.props;
		if (isReverting) {
			return (
				<div className={`${css(styleSheet.center, ...(styles || []))} ${className || ''}`}>
					<LoadingSpinner type='small' />
				</div>
			);
		}
		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} ${className || ''}`}>
				<div className={css(styleSheet.importData)}>{moment(importJob.dateCreatedUtc).format('MM-DD-YYYY') || ''}</div>

				<div className={css(styleSheet.importData)}>{getDisplayName(importJob.userReference, true)}</div>
				<div className={css(styleSheet.importDataLarge, baseStyleSheet.truncateText)}>
					<ConditionalAccess
						permission={AdminPermission.OnlyForDevelopers}
						or={AdminPermission.ModifyAccount}
						elseChildren={<>{importJob.additionalFields?.importFileName || ''}</>}
					>
						<button onClick={downloadFile} className={css(baseStyleSheet.brandLink)}>
							{importJob.additionalFields?.importFileName || ''}
						</button>
					</ConditionalAccess>
				</div>
				<div className={css(styleSheet.importData)}>{importJob.recordsProcessed || ''}</div>
				<div className={css(styleSheet.importDataLarge)}>
					{importJob.id || ''}
					<ConditionalAccess permission={AdminPermission.OnlyForDevelopers} elseChildren={null}>
						<span className={css(styleSheet.copy)} onClick={this.copyImportId}>
							<ClipboardIcon fillColor={brandPrimaryHover} hoverColor={brandPrimary} />
						</span>
					</ConditionalAccess>
				</div>
				<div className={css(styleSheet.importDataSmall)}>
					{showButton && (
						<ConditionalAccess permission={AdminPermission.RevertImport}>
							{!onForceRevertImport && (
								<button id={importJob.id} onClick={revertImport} className={css(baseStyleSheet.ctaButtonSmall)}>
									Revert
								</button>
							)}
						</ConditionalAccess>
					)}
					<ConditionalAccess permission={AdminPermission.OnlyForDevelopers}>
						{!!onForceRevertImport && (
							<button
								id={importJob.id}
								onClick={onForceRevertImport}
								className={css(baseStyleSheet.ctaButtonDestructiveSmall)}
							>
								Force
							</button>
						)}
					</ConditionalAccess>
				</div>
			</div>
		);
	}

	private copyImportId = () => {
		const { importJob } = this.props;

		const done = copyToClipboard(importJob.id);
		if (done) {
			toast.success('Copied import ID to clipboard!');
		} else {
			toast.error('Unable to copy to clipboard...');
		}
	};
}

export const ImportJobAccount = observer(_ImportJobAccount);
